import {
  addMaterialTypeApi,
  updateMaterialTypeApi,
  deleteMaterialTypeApi,
  getMaterialTypeByIdApi,
  queryMaterialTypeApi,
  addMaterialApi,
  deleteMaterialApi,
  updateMaterialApi,
  getMaterialByIdApi,
  setMaterialMsgIsValidApi,
  queryMaterialApi,
  setMaterialIsTopApi,
  getWinningRecordListApi,
  setShareActivityPrizeStateApi,
  getCoreIndexStatisticsApi,
  getCurDayNewAddCountApi,
  queryBKXHomePageApi,
  setMaterialTypeSortNumApi,
  queryBrandUserPageApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加素材类型
  async addMaterialTypeAction(context, param) {
    const res = await addMaterialTypeApi(param)
    return res
  },
  //  更新素材类型
  async updateMaterialTypeAction(context, param) {
    const res = await updateMaterialTypeApi(param)
    return res
  },
  //  删除素材类型
  async deleteMaterialTypeAction(context, param) {
    const res = await deleteMaterialTypeApi(param)
    return res
  },
  //  根据id获取素材类型
  async getMaterialTypeByIdAction(context, param) {
    const res = await getMaterialTypeByIdApi(param)
    return res
  },
  //  查询素材类型
  async queryMaterialTypeAction(context, param) {
    const res = await queryMaterialTypeApi(param)
    return res
  },
  //  添加素材
  async addMaterialAction(context, param) {
    const res = await addMaterialApi(param)
    return res
  },
  //  删除素材
  async deleteMaterialAction(context, param) {
    const res = await deleteMaterialApi(param)
    return res
  },
  //  更新素材
  async updateMaterialAction(context, param) {
    const res = await updateMaterialApi(param)
    return res
  },
  //  根据id获取素材
  async getMaterialByIdAction(context, param) {
    const res = await getMaterialByIdApi(param)
    return res
  },
  //  设置素材是否有效
  async setMaterialMsgIsValidAction(context, param) {
    const res = await setMaterialMsgIsValidApi(param)
    return res
  },
  //  查询素材
  async queryMaterialAction(context, param) {
    const res = await queryMaterialApi(param)
    return res
  },
  //  设置素材是否置顶
  async setMaterialIsTopAction(context, param) {
    const res = await setMaterialIsTopApi(param)
    return res
  },
  //  查询中奖记录列表
  async getWinningRecordListAction(context, param) {
    const res = await getWinningRecordListApi(param)
    return res
  },
  //  设置中奖记录状态
  async setShareActivityPrizeStateAction(context, param) {
    const res = await setShareActivityPrizeStateApi(param)
    return res
  },
  //  获取核心指数统计
  async getCoreIndexStatisticsAction(context, param) {
    const res = await getCoreIndexStatisticsApi(param)
    return res
  },
  //  获取当日新增统计
  async getCurDayNewAddCountAction(context, param) {
    const res = await getCurDayNewAddCountApi(param)
    return res
  },
  //  爆客侠-统计
  async queryBKXHomePageAction(context, param) {
    const res = await queryBKXHomePageApi(param)
    return res
  },
  //  设置素材类型排序
  async setMaterialTypeSortNumAction(context, param) {
    const res = await setMaterialTypeSortNumApi(param)
    return res
  },
  //  查询品牌用户分页数据
  async queryBrandUserPageAction(context, param) {
    const res = await queryBrandUserPageApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
